import { createRouter, createWebHistory } from 'vue-router';


// Load vuex store
import store from '../store';

// Load route views
import Home from '../views/Home';
import Crash from '../views/Crash';
import Wingo from '../views/Wingo';
import Roll from '../views/Roll';
import Blackjack from '../views/blackjack/Blackjack';
import BlackjackOverview from '../views/blackjack/BlackjackOverview';
import BlackjackTables from '../views/blackjack/BlackjackTables';
import BlackjackTable from '../views/blackjack/BlackjackTable';
import Duels from '../views/Duels';
import Mines from '../views/Mines';
import Towers from '../views/Towers';
import Unbox from '../views/unbox/Unbox';
import UnboxOverview from '../views/unbox/UnboxOverview';
import UnboxBox from '../views/unbox/UnboxBox';
import Battles from '../views/battles/Battles';

import BattlesOverview from '../views/battles/BattlesOverview';
import BattlesGame from '../views/battles/BattlesGame';
import BattlesCreate from '../views/battles/BattlesCreate';
import TurboTrade from '../views/turbo/TurboTradeView';
import FuturesTrade from '../views/futures/FuturesTradeView';
import Upgrader from '../views/Upgrader';
import Limiteds from '../views/limiteds/Limiteds';
import LimitedsDeposit from '../views/limiteds/LimitedsDeposit';
import LimitedsWithdraw from '../views/limiteds/LimitedsWithdraw';
import Leaderboard from '../views/Leaderboard';
import GameCategory from '@/components/GameCategory.vue';
import CasinoPlay from '@/views/CasinoPlay.vue';
import Slot from '@/views/Slot.vue';
import Promotions from '@/views/Promotions.vue';
import Bonus from '@/views/Bonus.vue';
import Rank from '@/views/Rank.vue';
import News from '@/views/News.vue';
import Helper from '@/views/Helper.vue';
import History from '@/views/History.vue';
import GameDetail from '@/components/GameDetail.vue';
import GameStart from "@/components/GameStart.vue"; // GameStart'ı içe aktar
import GameHistory from "@/views/GameHistory.vue"; // GameStart'ı içe aktar
import TransactionHistory from "@/views/TransactionHistory.vue"; // GameStart'ı içe aktar
import BonusHistory from '../views/BonusHistory.vue';
import UserProfile from "@/views/UserProfile.vue"; // GameStart'ı içe aktar
import Vip from "@/views/vip/index.vue";
import Task from "@/views/events/Task.vue";
import Battlepass from "@/views/battlepass/index.vue";
import Category from "@/components/GameCategory.vue";
const Profile = () => import(/* webpackChunkName: "group-user" */ '../views/profile/Profile');
const ProfileTransactions = () => import(/* webpackChunkName: "group-user" */ '../views/profile/ProfileTransactions');
const ProfileGames = () => import(/* webpackChunkName: "group-user" */ '../views/profile/ProfileGames');
const ProfileSettings = () => import(/* webpackChunkName: "group-user" */ '../views/profile/ProfileSettings');
const Rewards = () => import(/* webpackChunkName: "group-user" */ '../views/Rewards');
const Affiliates = () => import(/* webpackChunkName: "group-user" */ '../views/Affiliates');

const Admin = () => import(/* webpackChunkName: "group-admin" */ '../views/admin/Admin');
const AdminDashboard = () => import(/* webpackChunkName: "group-admin" */ '../views/admin/AdminDashboard');
const AdminUsers = () => import(/* webpackChunkName: "group-admin" */ '../views/admin/AdminUsers');
const AdminNotice = () => import(/* webpackChunkName: "group-admin" */ '../views/admin/AdminNotice');
const AdminAffiliates = () => import(/* webpackChunkName: "group-admin" */ '../views/admin/AdminAffiliates');
const AdminPromo = () => import(/* webpackChunkName: "group-admin" */ '../views/admin/AdminPromo');
const AdminCashier = () => import(/* webpackChunkName: "group-admin" */ '../views/admin/AdminCashier');
const AdminBoxes = () => import(/* webpackChunkName: "group-admin" */ '../views/admin/AdminBoxes');
const AdminRain = () => import(/* webpackChunkName: "group-admin" */ '../views/admin/AdminRain');
const AdminLeaderboards = () => import(/* webpackChunkName: "group-admin" */ '../views/admin/AdminLeaderboards');
const AdminFilter = () => import(/* webpackChunkName: "group-admin" */ '../views/admin/AdminFilter');
const AdminStats = () => import(/* webpackChunkName: "group-admin" */ '../views/admin/AdminStats');
const AdminSettings = () => import(/* webpackChunkName: "group-admin" */ '../views/admin/AdminSettings');
const AdminNews = () => import(/* webpackChunkName: "group-admin" */ '../views/admin/AdminNews');
const AdminGames = () => import(/* webpackChunkName: "group-admin" */ '../views/admin/AdminGames');

const AdminBonus = () => import(/* webpackChunkName: "group-admin" */ '../views/admin/AdminBonus');
const AdminSupport = () => import(/* webpackChunkName: "group-admin" */ '../views/admin/AdminSupport');


const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/promotions',
        name: 'Promotions',
        component: Promotions
    },
    {
  path: '/promotions/:code',
  name: 'PromotionDetail',
  component: () => import('@/views/promotions/PromotionDetail.vue'),
  props: true,
},
    {
        path: '/bonus',
        name: 'Bonus',
        component: Bonus
    },
    {
        path: '/history',
        name: 'History',
        component: History
    },
    {
        path: '/rank',
        name: 'Rank',
        component: Rank
    },
    {
        path: '/news',
        name: 'News',
        component: News
    },
    {
        path: '/helper',
        name: 'Helper',
        component: Helper
    },
    {
        path: '/crash',
        name: 'Crash',
        component: Crash
    },
    {
        path: '/wingo',
        name: 'Wingo',
        component: Wingo
    },
    {
        path: '/roll',
        name: 'Roll',
        component: Roll
    },
    {
        path: '/blackjack',
         name: 'Blackjack',
        component: Blackjack,
          redirect: { name: 'BlackjackOverview' },
        children: [
            {
                path: '',
                name: 'BlackjackOverview',
                component: BlackjackOverview
            },
            {
                path: 'tables',
                name: 'BlackjackTables',
                component: BlackjackTables
            },
            {
                path: 'table/:tableId',
                name: 'BlackjackTable',
                component: BlackjackTable
            }
        ]
    },
    {
        path: '/duels',
        name: 'Duels',
        component: Duels
    },
    {
        path: '/mines',
        name: 'Mines',
        component: Mines
    },
    {
        path: '/towers',
        name: 'Towers',
        component: Towers
    },
    {
        path: '/unbox',
        component: Unbox,
        children: [
            {
                path: '',
                name: 'UnboxOverview',
                component: UnboxOverview
            },
            {
                path: ':boxId',
                name: 'UnboxBox',
                component: UnboxBox
            }
        ]
    },
    {
        path: '/battles',
        component: Battles,
        children: [
            {
                path: '',
                name: 'BattlesOverview',
                component: BattlesOverview
            },
            {
                path: 'create',
                name: 'BattlesCreate',
                meta: {
                    auth: true
                },
                component: BattlesCreate
            },
            {
                path: ':gameId',
                name: 'BattlesGame',
                component: BattlesGame
            }
        ]
    },
    {
        path: '/futures',
        name: 'FuturesTrade',
        component: FuturesTrade
        
    },
     {
        path: '/turbo',
        name: 'TurboTrade',
        component: TurboTrade
    },
    {
        path: '/casino-play',
        name: 'CasinoPlay',
        component: CasinoPlay,
      },
    {
        path: '/upgrader',
        name: 'Upgrader',
        component: Upgrader
    },
    {
        path: '/limiteds',
        component: Limiteds,
        meta: {
            auth: true
        },
        children: [
            {
                path: 'deposit',
                name: 'LimitedsDeposit',
                component: LimitedsDeposit
            },
            {
                path: 'withdraw',
                name: 'LimitedsWithdraw',
                component: LimitedsWithdraw
            }
        ]
    },
    {
        path: '/vip',
        name: 'Vip',
        component: Vip // Yeni rotayı tanımlayın
      },
      {
        path: '/task',
        name: 'Task',
        component: Task // Yeni rotayı tanımlayın
      },
      {
        path: '/battlepass',
        name: 'Battlepass',
        component: Battlepass // Yeni rotayı tanımlayın
      },
      {
        path: '/category/:slug',
        name: 'Category',
        component: Category // Yeni rotayı tanımlayın
      },
    {
        path: '/Slot',
        name: 'Slot',
        component: Slot // Yeni rotayı tanımlayın
      },
      {
        path: '/category/:category',
        name: 'GameCategory',
        component: GameCategory
    },

      {
        path: '/game/:id', // :id oyun kodunu temsil eder
        name: 'GameStart',
        component: GameStart
    },
    {
        path: '/transactions', // :id oyun kodunu temsil eder
        name: 'TransactionHistory',
        component: TransactionHistory
    },
    {
        path: '/bonushistory', // :id oyun kodunu temsil eder
        name: 'BonusHistory',
        component: BonusHistory
    },
    {
        path: '/userprofile', // :id oyun kodunu temsil eder
        name: 'UserProfile',
        component: UserProfile
    },
    {
        path: '/gamehistory', // :id oyun kodunu temsil eder
        name: 'GameHistory',
        component: GameHistory
    },
    {
        path: '/profile',
        component: Profile,
        meta: {
            auth: false
        },
        children: [
            {
                path: '',
                name: 'ProfileTransactions',
                component: ProfileTransactions
            },
            {
                path: 'games',
                name: 'ProfileGames',
                component: ProfileGames
            },
            {
                path: 'settings',
                name: 'ProfileSettings',
                component: ProfileSettings
            }
        ]
    },
    {
        path: '/rewards',
        name: 'Rewards',
        meta: {
            auth: true
        },
        component: Rewards
    },
    {
        path: '/affiliates',
        name: 'Affiliates',
        meta: {
            auth: true
        },
        component: Affiliates
    },
    {
        path: '/leaderboard',
        name: 'Leaderboard',
        component: Leaderboard
    },
    {
        path: '/admin',
        component: Admin,
        meta: {
            auth: true,
            admin: true
        },
        children: [
            {
                path: '',
                name: 'AdminDashboard',
                component: AdminDashboard
            },
            {
                path: 'users',
                name: 'AdminUsers',
                component: AdminUsers
            },
            {
                path: 'notice',
                name: 'AdminNotice',
                component: AdminNotice
            },
            {
                path: 'news',
                name: 'AdminNews',
                component: AdminNews   
            },
            {
                path: 'games',
                name: 'AdminGames',
                component: AdminGames   
            },
          
            {
                path: 'bonus',
                name: 'AdminBonus',
                component: AdminBonus   
            },
            {
                path: 'support',
                name: 'AdminSupport',
                component: AdminSupport   
            },
            {
                path: 'affiliates',
                name: 'AdminAffiliates',
                component: AdminAffiliates
            },
            {
                path: 'promo',
                name: 'AdminPromo',
                component: AdminPromo
            },
            {
                path: 'cashier',
                name: 'AdminCashier',
                component: AdminCashier
            },
            {
                path: 'boxes',
                name: 'AdminBoxes',
                component: AdminBoxes
            },
            {
                path: 'rain',
                name: 'AdminRain',
                component: AdminRain
            },
            {
                path: 'leaderboard',
                name: 'AdminLeaderboard',
                component: AdminLeaderboards
            },
            {
                path: 'filter',
                name: 'AdminFilter',
                component: AdminFilter
            },
            {
                path: 'stats',
                name: 'AdminStats',
                component: AdminStats
            }, 
            {
                path: 'settings',
                name: 'AdminSettings',
                component: AdminSettings
            }
        ]
    },
    {
        path: '/verify',
        beforeEnter: (to, from, next) => {
            const data = { userId: to.query.userId, token: to.query.token };
            store.dispatch('authSendCredentialsVerify', data);

            next('/');
        }
    },
    {
        path: '/reset',
        beforeEnter: (to, from, next) => {
            store.dispatch('modalsSetData', { userId: to.query.userId, token: to.query.token });
            store.dispatch('modalsSetShow', 'Reset');

            next('/');
        }
    }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach(async (to, from, next) => {
  const token = store.getters.authToken;
  const user = store.getters.authUser.user;
  const loading = store.getters.authUser.loading;

  // 🔄 Token var ama user yoksa → bekleyerek yükle
  if (token && !user && !loading) {
    try {
      await store.dispatch('authGetUser');
    } catch (e) {
      store.dispatch('authLogoutUser');
      return next('/');
    }
  }

  const freshUser = store.getters.authUser.user;

  // 🔐 Auth required
  if (to.matched.some(r => r.meta.auth) && !freshUser) {
    return next('/');
  }

  // 🛡 Admin required
  if (to.matched.some(r => r.meta.admin)) {
    if (!freshUser || freshUser.rank !== 'admin') {
      return next('/');
    }
  }

  next();
});


export default router;
